import { addDays, endOfDay, format, startOfDay } from 'date-fns';
import type Company from '@/domain/model/business/Company.ts';
import type PeriodType from '@/infrastructure/support/PeriodType.ts';

export default class AggregatorDTO {
  company: Company;
  plant;
  meter;
  dateSelection;

  constructor(company: Company, plant, meter, dateSelection) {
    this.company = company;
    this.plant = plant;
    this.meter = meter;
    this.dateSelection = dateSelection;
  }

  getPeriodType(): PeriodType {
    return this.dateSelection.periodType as PeriodType;
  }

  getStartDateString(): string {
    const startDateStartOfDay = startOfDay(
      this.dateSelection.dateRange.startDate,
    );
    return format(startDateStartOfDay, 'yyyy-MM-dd');
  }

  getEndDateString(): string {
    const endDate = addDays(this.dateSelection.dateRange.endDate, 1);
    const endDateEndOfDay = endOfDay(endDate);
    return format(endDateEndOfDay, 'yyyy-MM-dd');
  }
}
